import Analytics from '@monolith/legacy/services/analytics';
import { UserClick, UserClickOptions } from '@ankorstore/events-tracking';

export const useTracking = () => {
  const trackUserClick = (properties: UserClickOptions) => {
    Analytics.track(UserClick(properties));
  };

  return {
    trackUserClick,
  };
};
